/**
 * <s-sticky-column> — sticky info column that first scrolls with the page.
 *
 * Short column: sticks 6rem below the top (under the header).
 * Tall column: sticks only once its bottom edge reaches the viewport bottom, so buyers can read
 * everything first while the gallery keeps scrolling. Sets --sticky-top in px.
 */
class SStickyColumn extends HTMLElement {
  #ro;
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.#ro = new ResizeObserver(() => this.#update());
    this.#ro.observe(this);
    window.addEventListener('resize', () => this.#update(), { signal: this.#ac.signal, passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.#ro?.disconnect();
    this.#ac?.abort();
  }

  #update() {
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    const headerGap = 6 * rem;
    const bottomGap = 1.5 * rem;
    const top = Math.min(headerGap, window.innerHeight - this.offsetHeight - bottomGap);
    this.style.setProperty('--sticky-top', `${Math.round(top)}px`);
  }
}

if (!customElements.get('s-sticky-column')) customElements.define('s-sticky-column', SStickyColumn);
